export default __webpack_public_path__ + "static/media/company.d189197d.png";